import { Wallet } from 'lucide-react';
import React from 'react';

import { Button } from '@/components/ui/button';

interface ZeroCustodialPromptProps {
    onFund: () => void;
}

const ZeroCustodialPrompt: React.FC<ZeroCustodialPromptProps> = ({
    onFund,
}) => {
    return (
        <div className="flex flex-col items-center gap-4 rounded-xl border border-border bg-secondary/40 px-4 py-6">
            <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-primary/10">
                <Wallet size={20} className="text-primary" />
            </div>
            <div className="text-center">
                <p className="text-sm font-semibold text-foreground">
                    Deposit once, trade instantly
                </p>
                <p className="mt-1 max-w-[250px] text-xs text-muted-foreground">
                    No wallet popups and no gas per trade, one deposit and
                    every trade after it is a single click.
                </p>
            </div>
            <Button size="lg" onClick={onFund} className="w-full gap-2">
                <Wallet size={16} />
                Deposit to start
            </Button>
        </div>
    );
};

export default ZeroCustodialPrompt;
